
module.config(function($stateProvider) {

    $stateProvider.state('program.model', {
        url: '/model',
        defaultChild: 'program.model.basic',
        templateUrl: 'programs/programModel/base',
        resolve: {
            log: function(program, LogInfo) {
                var log = new LogInfo(program, 'model');
                return log.load();
            }
        },
        controller: function($scope, log) {
            $scope.log = log;
        }
    });

    $stateProvider.state('program.model.basic', {
        url: '',
        templateUrl: 'programs/programModel/programModel',
        permission: 'viewModel',
        resolve: {
            programModel: function(ModelService, program) {
                return ModelService.get('program_model', program.id);
            },
        },
        controller: 'ProgramModelController',
    });

    $stateProvider.state('program.model.fiscal', {
        abstract: true,
        controller: 'FiscalBaseController',
        templateUrl: 'empty',
        resolve: {
            config: function(ScorecardService) {
                return ScorecardService.loadConfig();
            },
            scorecard: function(ScorecardService, program) {
                return ScorecardService.loadScorecard(program);
            },
        },
    });

    $stateProvider.state('program.model.fiscal.practices', {
        url: '/fiscal-practices',
        templateUrl: 'programs/programModel/practices',
        controller: 'ScorecardController',
        controllerAs: '$ctrl',
        data: {
            is_ybusa: false,
        }
    });

    $stateProvider.state('program.model.fiscal.scorecard', {
        url: '/fiscal-scorecard',
        templateUrl: 'programs/programModel/scorecard',
        controller: 'ScorecardController',
        controllerAs: '$ctrl',
        data: {
            is_ybusa: true,
        },
    });

    $stateProvider.state('program.model.fiscal.history', {
        url: '/fiscal-history',
        defaultChild: 'program.model.fiscal.history.overview',
        resolve: {
            history: function(scorecard, ScorecardService) {
                return ScorecardService.getHistory(scorecard);
            }
        },
        views: {
            '@program': {
                templateUrl: 'programs/programModel/historyBase',
                controller: 'ScorecardHistoryBaseController',
                controllerAs: '$ctrl',
            },
        },
    });

    $stateProvider.state('program.model.fiscal.history.overview', {
        templateUrl: 'programs/programModel/historyOverview',
        controller: 'ScorecardHistoryBaseController',
        controllerAs: '$ctrl',
        resolve: {
            config: function(config) { return config.model; },
        }
    });

    $stateProvider.state('program.model.fiscal.history.section', {
        templateUrl: 'programs/programModel/historySection',
        params: {sectionId: undefined},
        controller: 'ScorecardHistoryBaseController',
        controllerAs: '$ctrl',
        resolve: {
            config: function($stateParams, config) {
                return config.sections.findId($stateParams.sectionId)
            }
        }
    });
});
